import React from 'react';
import HeroSection from './Hero';
import Footer from '../Footer';
import Navbar from '../NavBar';
import ProductSection from './ProductSection';
import BannerSection from './BannerSection';
import PartnersSection from './PartnersSection';
import TrendingSection from './TrendingSection';

const Index = () => {

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20 lg:pt-28 bg-black" />
      <HeroSection />
      <ProductSection />
      <PartnersSection />
      <TrendingSection />
      <BannerSection />
      <Footer />
    </div>
  );
};

export default Index;
